import React, { useState, useEffect } from 'react';
import styled from "styled-components";
import Navbar from '../../components/layout/Navbar/Navbar';
import Sidebar from '../../components/layout/Sidebar/Sidebar';
import ProfileHeader from '../../components/Profile/ProfileHeader';
import ProfileUserInfo from '../../components/Profile/ProfileUserInfo';
import { getCargoIdSidebar } from '../../constants/sidebarConfig';
import apiService from '../../services/api';

const NAVBAR_HEIGHT = 65;
const SIDEBAR_WIDTH = 300;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  margin-top: 60px;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: ${SIDEBAR_WIDTH}px;
  overflow-y: auto;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
`;

const ProfileBody = styled.div`
  padding: 12px 40px 40px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Profile = () => {
  const [user, setUser] = useState(null);
  const [sidebarItems, setSidebarItems] = useState([]);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await apiService.getCurrentUser();
        setUser(userData);
        const filteredItems = getCargoIdSidebar(userData.cargoId);
        setSidebarItems(filteredItems);
      } catch (err) {
        console.error('Erro ao buscar usuário:', err);
      }
    };

    fetchUser();
  }, []);

  return (
    <PageWrapper>
      <Navbar 
        onLogout={apiService.logout}
        showHome={true}
        showNotifications={true}
        showProfile={true}
        showLogout={true}
        user={user}
      />
      <ContentWrapper>
        <Sidebar items={sidebarItems} />
        <MainContent>
          <ProfileHeader />
          <ProfileBody>
            {user && <ProfileUserInfo userData={user} editable />}
          </ProfileBody>
        </MainContent>
      </ContentWrapper>
    </PageWrapper>
  );
};

export default Profile;
